import React from 'react';
import { Droppable } from 'react-beautiful-dnd';

import IconHide from './IconHide';
// import IconLock from './IconLock';
import { getListStyle } from '../../../components/Mapbox/Utils';
import UnScheduledSteps from './UnScheduledSteps';

const UnScheduled = ({
  steps,
  realSteps,
  stepsHovered,
  setStepsHovered,
  onClickStep,
  onHoverStep,
  handleCloseStepPopup,
  onClickHide,
  isDragging,
  riderIdsHide,
  // actionDnd,
}) => {
  const isHide = riderIdsHide?.includes('unassigned');

  return (
    <div className="tr">
      <div className="td">
        <div className="driver-name">
          {/* <IconLock hidden={true} /> */}
          <IconHide isHide={isHide} onClickHide={() => onClickHide('unassigned')} />
          Unscheduled ({steps.length})
        </div>
      </div>
      <div className="td" style={{ width: '100%' }}>
        <Droppable
          key="unscheduled"
          droppableId="unscheduled"
          direction="horizontal"
          // isDropDisabled={actionDnd === 'optimize'}
        >
          {(provided, snapshot) => (
            <div
              className={`scrollCustom unscheduled-steps ${isDragging && 'isDragging'}`}
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{
                maxWidth: 'calc(100vw - 710px)',
                minWidth: '12px',
                display: 'flex',
                alignItems: 'center',
                height: '40px',
                overflow: 'auto',
                zIndex: 999,
                ...getListStyle(isDragging, snapshot.isDraggingOver),
              }}
            >
              <UnScheduledSteps
                steps={steps.reduce((array, item) => array.concat(item), [])}
                realSteps={realSteps}
                stepsHovered={stepsHovered}
                setStepsHovered={setStepsHovered}
                onClickStep={onClickStep}
                onHoverStep={onHoverStep}
                handleCloseStepPopup={handleCloseStepPopup}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </div>
  );
};

export default UnScheduled;
